


























import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import PaidServiceItem from '~/components/car/classifieds/form/fieldsets/fields/handlers/rentals/PaidServiceItem.vue'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

interface ExtraService {
  value: string
  payment: string
  price: string
}

export default defineComponent({
  components: { FieldError, PaidServiceItem },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedPaymentOptions = ref<ExtraService[]>([])

    function onValue(v: Ref<any>) {
      selectedPaymentOptions.value =
        v.value?.map((val: ExtraService) => {
          return {
            price: val.price.toString(),
            payment: val.payment,
            value: val.value
          }
        }) || []
    }
    const { error, debouncedValueChanged } = useClassifiedForm(props, {
      onValue
    })

    const paidServicesOptions = computed(() => specs.value.values)

    function handlePaidServiceItemChange(item: any) {
      const { enabled, value, payment, price } = item

      const index = selectedPaymentOptions.value.findIndex(
        o => o.value === value
      )

      const entry = {
        value,
        payment,
        price
      }
      if (index > -1) {
        selectedPaymentOptions.value[index] = { ...entry }
      } else if (enabled) {
        selectedPaymentOptions.value.push(entry)
      } else {
        selectedPaymentOptions.value.splice(index, 1)
      }

      debouncedValueChanged(name.value, selectedPaymentOptions.value)
    }

    function serviceItemIsEnabled(value: string): boolean {
      return Boolean(selectedPaymentOptions.value.find(v => v.value === value))
    }
    function getServiceItemPayment(value: string): string | undefined {
      return selectedPaymentOptions.value.find(v => v.value === value)?.payment
    }
    function getServiceItemPrice(value: string): string | undefined {
      return selectedPaymentOptions.value.find(v => v.value === value)?.price
    }

    return {
      error,
      paidServicesOptions,
      handlePaidServiceItemChange,
      selectedPaymentOptions,
      serviceItemIsEnabled,
      getServiceItemPayment,
      getServiceItemPrice
    }
  }
})
